import React, { useState, useEffect } from 'react';
import { useForm, Controller, SubmitHandler } from "react-hook-form";
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';
import * as yup from "yup";
import cn from 'classnames';
import { yupResolver } from '@hookform/resolvers/yup';

import { Input, Button } from 'components';
import { resetPassword } from 'services/auth'
import { toast } from 'react-toastify';

interface IFormInputs {
    email: string
}

export const ForgotPasswordForm = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    
    useEffect(() => {
        setTimeout(() => {
            setFadeIn(true);
        }, 500);
    }, [])

    const schema = yup.object({
        email: yup.string().email(t('error.invalidEmail')).required(t('error.requiredEmail'))
    }).required();

    const { handleSubmit, control, reset, formState: { errors } } = useForm<IFormInputs>({
        resolver: yupResolver(schema)
    });

    const handleOnSubmit: SubmitHandler<IFormInputs> = async data => {
        try {
            setLoading(true);
            await resetPassword(data.email);
            reset();
            toast.info(t("resetEmailSent"));
            navigate('/auth/reset-password');
        } catch (error: any) {
            toast.error(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div>
            <h2 className={cn("mb-8 text-3xl c-orange font-light enter-y delay-100", {fadeIn})}>{t('forgotPassword')}</h2>
            <form onSubmit={handleSubmit(handleOnSubmit)}>
                <Controller
                    name="email"
                    control={control}
                    rules={{ required: true }}
                    defaultValue={''}
                    render={({ field, fieldState }) =>
                        <Input
                            className={cn("block mb-5 enter-y delay-200", {fadeIn})}
                            labelClass="sm"
                            label={t('email')}
                            errors={errors.email}
                            placeholder={t('enterYourEmailAddress')}
                            fieldState={fieldState}
                            {...field}
                        />

                    }
                />
                <div className={cn("flex justify-between mt-8 enter-y delay-300", {fadeIn})}>
                    <Button type="submit" loading={loading} className="c-orange font-extrabold text-sm">+ {t('send')}</Button>
                    <Button type="link" underline to="/auth/login" className="c-orange text-sm">{t('login')}</Button>
                </div>
            </form>
        </div>
    )

}